<template>
<section id="education" class="education">
  <div class="resume-content">
      <p class="headline__subtitle animate-headline">
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="13px" height="13px" viewBox="0 0 13 13"
          fill="currentColor">
          <path fill="currentColor" d="M5.6,12.6c-0.5-0.8-0.7-2.4-1.7-3.5c-1-1-2.7-1.2-3.5-1.7C-0.1,7-0.1,6,0.4,5.6c0.8-0.5,2.3-0.6,3.5-1.8
            C5,2.8,5.1,1.2,5.6,0.4C6-0.1,7-0.1,7.4,0.4c0.5,0.8,0.7,2.4,1.8,3.5c1.2,1.2,2.6,1.2,3.5,1.7c0.6,0.4,0.6,1.4,0,1.7
            C11.8,7.9,10.2,8,9.1,9.1c-1,1-1.2,2.7-1.7,3.5C7,13.1,6,13.1,5.6,12.6z" />
        </svg>
        <span>Certifications</span>
      </p>
<div class="resume-items">
  <div class="education-items" v-for="(item, index) in educationItems" :key="index">
  <div class="education-item" >
      <div class="item-header">
        <h5 class="title">{{ item.title }}</h5>
        <span class="year">{{ item.year }}</span>

      </div>
      <p style="color: #AD8330;"><strong>{{ item.place }}</strong></p>
      <p>{{ item.description }}</p>

    </div>
  </div>
  </div>
  </div>
</section>

</template>

<script>
export default {
  props: {
    educationItems: {
      type: Array,
      required: true
    }
  },
};
</script>

<style scoped>
.headline__subtitle {
  display: inline-flex;
  align-items: center;
  height: 3.4rem;
  padding: 0 1.4rem;
  border-radius: var(--_radius-s);
  border: 1px solid var(--stroke-elements);
  font: normal 700 18px/3.3rem var(--_font-default); /* Ubah 1.3rem menjadi 18px */
  margin-bottom: 1rem;
}

.resume-content {
margin-top: 40px;
}
.education-items p {
  font-size: 18px;
  position: relative;
  padding: 0 1.5rem;
}

.education-items {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 10px;
  /* margin-right: 40px; */
   border-radius: var(--_radius-s);
  border: 2px solid rgba(176, 176, 176, 0.2) ;
}



.education-item {
  text-align: left;
  padding: 15px;
  /* background: #f9f9f9; */
  border-radius: 10px;
  /* margin-top: 40px;
  margin-right: 40px; */
}

.item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 5px;
  padding: 0 1.5rem;
}

.title {
  font-weight: bold;
  font-size: 18px;
}

.year {
  font-size: 16px;
  color: #666;
}
</style>
